import type { SplitTime, TimeValidations } from '@library/types/dates';
import type { DateObjectUnits } from 'luxon';
import { DateTime } from 'luxon';
import { createContext } from 'react';
import { getSplitTime } from '@library/component-utils/dateTime';

export const TimePickerContext = createContext<{
  date: DateTime;
  displayValues: SplitTime;
  initialTime: DateTime;
  maxDate?: DateTime;
  minDate?: DateTime;
  onChange?: (time: DateObjectUnits) => void;
  placeholderSplitTime: SplitTime;
  proposedTime: DateTime;
  resetTime: () => void;
  setDisplayValues: (time: SplitTime) => void;
  setInitialTime: (time: DateTime) => void;
  setProposedTime: (time: DateTime) => void;
  validateTime: ({
    inputName,
    newTime,
    value
  }: {
    inputName: 'hour' | 'minutes';
    newTime: DateTime;
    value: string;
  }) => void;
  splitTime: SplitTime;
  validations: TimeValidations;
}>({
  date: DateTime.now(),
  displayValues: getSplitTime(DateTime.now()),
  initialTime: DateTime.now(),
  maxDate: undefined,
  minDate: undefined,
  onChange: () => {},
  placeholderSplitTime: getSplitTime(DateTime.now()),
  proposedTime: DateTime.now(),
  resetTime: () => {},
  setDisplayValues: () => {},
  setInitialTime: () => {},
  setProposedTime: () => {},
  validateTime: () => {},
  splitTime: getSplitTime(DateTime.now()),
  validations: {
    isAfterMax: false,
    isBeforeMin: false,
    isError: false,
    isHourError: false,
    isHourValid: false,
    isMinuteError: false,
    isMinuteValid: false,
    uniqueStartTimes: []
  }
});
